
import Vue from 'vue'
import moment from 'moment'
import axios from 'axios'
import {currentLang} from '../../config.js'
import 'babel-polyfill';

Vue.filter('round', function(value, decimals) {
    if (!value) {
        value = 0;
    }

    if (!decimals) {
        decimals = 0;
    }

    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
    return value;
});

Vue.config.productionTip = false;
moment.locale(currentLang);
Vue.prototype.$moment = moment;

require('es6-promise').polyfill();
Vue.prototype.$http = axios;

export default Vue;



// WEBPACK FOOTER //
// ./src/components/common/vue.js